var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "go-section go-section-contents creates" },
    [
      _c(
        "div",
        { staticClass: "go-section-header" },
        [
          _c("div", { staticClass: "go-page-header-type2" }, [
            _c("div", { staticClass: "go-page-title" }, [
              _vm._v(
                _vm._s(_vm.$t("my-create.common.navbar.journal")) +
                  " " +
                  _vm._s(_vm.total ? "(" + _vm.total + ")" : "(0)")
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("search-filter", {
            on: {
              filterChange: _vm.handleFilterChange,
              changeDate: _vm.handleChangeDate,
              changeLang: _vm.handleChangeLanguage,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "go-section-body" },
        [
          _c("resource-grid-view", {
            attrs: {
              "resource-items": _vm.resourceItems,
              "load-more-able": _vm.isActivated && _vm.loadMoreAble,
              isShowCardEvent: false,
              isDisabledRemoveLoading: true,
              "is-hide-add-reference": true,
              reportLoadingCardInHeaderList: _vm.loadingList,
            },
            on: { "load-more": _vm.onLoadMore },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.loading ? _c("list-loading") : _vm._e(),
      _vm._v(" "),
      _vm.isNoData && !_vm.loading && _vm.fetchCount > 1
        ? _c("search-empty")
        : _vm._e(),
      _vm._v(" "),
      _vm.isNoData && !_vm.loading && _vm.fetchCount <= 1
        ? _c("NoDataComponent", {
            attrs: { title: _vm.MY_CREATE_TYPES.JOURNALIST_NOTE },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }